<template>
  <div
    class="alert alert-dismissible alert-base"
    v-if="showInstallBanner"
    style="text-align:center; border-radius: 5px; color: #000"
  >
    <b>
      {{ $t("home.installLabel.firstPart") }}
      <a href="#" @click.prevent="install" style="color: white">
        {{ $t("home.installLabel.secondPart") }}
      </a>
      {{ $t("home.installLabel.thirdPart") }}
    </b>
  </div>
</template>

<script>
let installEvent;
export default {
  name: "installPrompt",
  data() {
    return {
      showInstallBanner: false,
    };
  },
  created() {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      installEvent = e;
      this.showInstallBanner = true;
    });
  },
  methods: {
    install() {
      this.showInstallBanner = false;
      installEvent.prompt();
      installEvent.userChoice.then(() => {
        installEvent = null;
      });
    },
  },
};
</script>
